import { Box, Chip } from '@mui/material'
import { DensityStyleTypes } from '../../../../types'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { renderColorByString } from 'components/DataGrid/renderColorByString'

interface RenderTypeProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
}

const RenderDealTypeCell: React.FC<RenderTypeProps> = ({ params, densityStyles }) => {
  const { type } = params?.row ?? {}
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
      }}
    >
      <Chip
        label={type}
        sx={{
          backgroundColor: 'transparent',
          textAlign: 'left',

          color: renderColorByString(type),
          fontWeight: 'bold',
          width: '100%',
          height: '100%',
          borderRadius: '4px',
        }}
      />
    </Box>
  )
}
export default RenderDealTypeCell
